import * as React from 'react';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { HeaderNavToolbar } from './nav-lob-toolbar/header-nav-toolbar';
import { HeaderImageToolbar } from './header-image-toolbar';
import { getGCSectionData } from './gc-section-data';
var HeaderLogoToolbar = function (_a) {
  var analytics = _a.analytics,
    globalComponentsContext = _a.globalComponentsContext,
    page = _a.page,
    minimal = _a.minimal,
    simplified = _a.simplified;
  var headerImg = getGCSectionData(globalComponentsContext, 'header', 'headerImg');
  return React.createElement(UitkLayoutFlex, {
    alignItems: "center"
  }, React.createElement(UitkLayoutFlexItem, null, React.createElement(HeaderImageToolbar, {
    headerImg: headerImg
  })), React.createElement(UitkLayoutFlexItem, null, React.createElement(HeaderNavToolbar, {
    analytics: analytics,
    globalComponentsContext: globalComponentsContext,
    page: page,
    showHeaderNavMenuLinks: true,
    minimal: minimal,
    simplified: simplified
  })));
};
export { HeaderLogoToolbar };